// extracted by mini-css-extract-plugin
export default {"big":"Text_big__J9pnF","small":"Text_small__gjHPX","error":"Text_error__+-766"};